import React, { useContext } from "react";
import { Route, Redirect } from "react-router";
import { AuthContextDispatchContext } from "../context/auth/AuthContext";
import DashboardLayout from "../layouts/Dashboard.layout";

export function PrivateRoute({ component: Component, ...rest }) {
  const { isLogged } = useContext(AuthContextDispatchContext);

  return (
    <Route
      {...rest}
      render={(props) =>
        isLogged === true ? (
          <DashboardLayout>
            <Component {...rest} />
          </DashboardLayout>
        ) : (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        )
      }
    />
  );
}
